/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import {useEffect} from "react";
import {guardarDoc} from "../../../Servicios/BD/guardarDoc";
import {useCargador} from "../../../Modulo_Cargador/Hooks/useCargador";
import logoRedondo from "../../../Recursos/logo_redondo.svg";
import {obtenerValorTotal} from "../../Utilidades/obtenerValorTotal";
import Formulario_Reserva_Descuentos from "../../Formularios/Reservas/Formulario_Reserva_Descuentos";
import {obtenerValorSaldo} from "../../Utilidades/obtenerValorSaldo";

const Dialogo_Descuentos = ({datos, cerrar, realizado}) => {
    const {
        props,
        obtenerEntidad
    } = useFormulario({valoresDefecto: datos})
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logoRedondo,
        funcionUno: realizado,
        funcionDos: cerrar,
        key: 'uno'
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        // entidad.valor = obtenerValorTotal(entidad)

        iniciarCarga('Subiendo datos')
        let result = await guardarDoc('reservas', entidad)
        if (result.res) {
            terminar({aviso: 'Datos actualizados con exito'})
        } else {
            terminar({aviso: 'Ups! no se subieron los datos, intentalo nuevamente', variante: 'error'})
        }

    }

    const obtenerTotalDescuentos = (arrDescuentos=[]) => {

        let total = 0
        for (let i = 0; i < arrDescuentos.length; i++) {
            total += parseInt(arrDescuentos[i].valor)
        }

        return total
    }


    useEffect(() => {

        let adicionales = props.getValues('adicionales')
        let descuentos = props.getValues('descuentos')
        let tarifa = props.getValues('tarifa')
        let tarifaAcompanante = props.getValues('tarifaAcompanante')
        let tarifaNinos = props.getValues('tarifaNinos')
        let numNoches = props.getValues('numNoches')
        let numAcompanantes = props.getValues('numAcompanantes')
        let numNinos = props.getValues('numNinos')
        let abonos = props.getValues('abonos')

        if (descuentos || adicionales) {
            let total = obtenerValorTotal({
                adicionales: adicionales,
                descuentos: descuentos,
                tarifa: tarifa,
                tarifaAcompanante: tarifaAcompanante,
                tarifaNinos: tarifaNinos,
                numNoches: numNoches,
                numAcompanantes: numAcompanantes,
                numNinos: numNinos
            })
            props.setValue('valor', total)
            props.setValue('valorSaldo', obtenerValorSaldo(total, abonos))
            props.setValue('valorDescuentos', obtenerTotalDescuentos(descuentos))
        }


    }, [props]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Reserva_Descuentos props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Descuentos